module.exports = __webpack_public_path__ + "static/media/xb3.f851f2a2.png";